import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Ghost, ArrowLeft, LogIn } from "lucide-react";

export default function NotFound() {
  const location = useLocation();
  return (
    <div className="min-h-screen grid place-items-center bg-slate-50 dark:bg-slate-950 px-4">
      <div className="max-w-lg w-full text-center space-y-6" data-testid="not-found-page">
        <div className="mx-auto w-16 h-16 rounded-2xl bg-orange-100 dark:bg-orange-500/20 grid place-items-center">
          <Ghost className="w-8 h-8 text-orange-500" />
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-orange-500 font-semibold">404</div>
          <h1 className="font-display text-3xl font-bold mt-1">Page introuvable</h1>
          <p className="text-sm text-slate-500 dark:text-slate-400 mt-2">
            L'adresse <span className="font-mono text-slate-700 dark:text-slate-300">{location.pathname}</span> n'existe pas.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            data-testid="not-found-home-btn"
            className="btn-pill inline-flex items-center justify-center gap-2 bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 text-slate-800 dark:text-slate-200 font-semibold px-5 py-2.5 rounded-full transition-colors"
          >
            <ArrowLeft className="w-4 h-4" /> Accueil
          </Link>
          <Link
            to="/login"
            data-testid="not-found-login-btn"
            className="btn-pill inline-flex items-center justify-center gap-2 bg-orange-500 hover:bg-orange-600 text-white font-semibold px-5 py-2.5 rounded-full transition-colors"
          >
            <LogIn className="w-4 h-4" /> Se connecter
          </Link>
        </div>
      </div>
    </div>
  );
}
